module.exports = __webpack_public_path__ + "static/media/datosGenerales.f0e321cd.png";